export default __webpack_public_path__ + "static/media/my_profile_header.8d8d0768.svg";